exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal{background-color:#fff}.modalTitle{display:flex;justify-content:space-between}.modalTitle .titleText{width:75%}.mainText{line-height:normal}.buttonContainer{margin-top:40px;display:flex;justify-content:space-between}", ""]);

